<template>
    <el-row>
      <headertop></headertop>
      <div class="main">
       <div class="left">
         <div style="  text-align:center;">
            <img :src= teacherList.img style="height: 300px;" />
         </div>

         <p>{{teacherList.name}}</p>
         <p style="color:#8E8E8E;" v-html="teacherList.content"></p>
         <div style="color:#8E8E8E;" v-html="teacherList.info"></div>
       </div>
       <div class="right">
        <div class="right_head">
          视频列表
          </div>
        <div class="right_tow">
          <div class="right_tow_left">
            显示：<el-dropdown split-button @command="down">
                        {{feny}}
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item  command="10">10</el-dropdown-item>
                      <el-dropdown-item  command="20">20</el-dropdown-item>
                      <el-dropdown-item  command="50">50</el-dropdown-item>
                      <el-dropdown-item  command="100">100</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
          </div>
          <!-- <div class="right_tow_right">
            查询：<el-input v-model="input" placeholder="请输入内容"  style="width: 50%;" @keyup.enter.native="intupbutton"></el-input>
          </div> -->
        </div>
        <div class="right_content">
          <el-table
              :data="liveList"
               style="width: 100%"
              :default-sort = "{prop: 'num time'}"
              >
              <el-table-column
                prop="num"
                label="NO"
                sortable
                width="180">
              </el-table-column>
             <el-table-column label="视频封面">
             　　<template slot-scope="scope">
             　　　　<img :src="scope.row.img" width="60" height="40" class="head_pic"/>
             　　</template>
             </el-table-column>
             <el-table-column
               prop="name"
               label="视频名称"
               sortable
               width="180">
             </el-table-column>
             <el-table-column
               prop="time"
               label="发布时间"
               sortable
               width="180">
             </el-table-column>
               <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        @click="handleEdit(scope.row)">查看</el-button>
                    </template>
                  </el-table-column>
            </el-table>
        </div>
        <el-pagination background small   :page-size='pagingList.per_page' :current-page='pagingList.current_page'
          layout="prev, pager, next" :total='pagingList.total'  class="center" style="padding: 0;margin: 30px 0;"  @current-change="(val) => handleCurrentChange(val)">
        </el-pagination>
       </div>
      </div>
      <footerbom></footerbom>
    </el-row>
</template>

<script>
 import Header from '../../components/index/public/NavHeader.vue';
 import Footer from '../../components/index/public/NavFooter.vue';
  export default {
    name: 'App',
    data() {
      return {
      input:"",
      num:this.$route.query.num,
      feny:10,//显示条数据
      liveList:[],
      teacherList:[],
      pagingList:[],
            }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
    },
    mounted: function (){
       this.get_task_info(1,10);
       this.get_teacher_list();

    },
    methods: {
      // intupbutton(){
      //   alert(this.input);

      // },
      //点击查看
      handleEdit(row){
        this.$router.push({path:'/courseplay',query:{num:row.num,type:'0',resource:'v'}})
      },
      //显示多少条数据
      down(num){
        this.feny=num;
        this.get_task_info(1, num);
      },
      get_teacher_list(){
        let _this = this;
          _this.axios
        .get("/v2/user_teacher/get_list", {
          params:{num:_this.num},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                  _this.teacherList=res.data.data
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      get_task_info(pagenum,limitnum){
        let _this = this;
          _this.axios.get("/v2/user_teacher/get_video_list",
       {params:{teacher:_this.num,page:pagenum,limit:limitnum,}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
             _this.liveList=res.data.data.data;
             _this.pagingList=res.data.data;
            _this.pagingList.per_page=parseInt( _this.pagingList.per_page);

            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });

      },
        formatter(row, column) {
              return row.address;
            },
        handleCurrentChange(val){
          this.get_task_info(val ,this.feny);
        }

    },

    }
</script>


<style scoped>
  .main{
   min-height: calc(100vh - 330px);
   width: 70%;
   padding: 20px;
   margin: 0 15%;
   z-index: 100;
   display: flex;
  }
  .left{
    padding: 20px;
    flex:2;
    background-color: white;
    height: 100%;
  }
  .right{
    flex: 7;
    margin-left: 2%;
    background-color: white;

    border:1px solid #d0d0d0;
    border-radius: 1%;
}
 .right_head{
  width: 99%;
  height:40px;
  padding-left:10px ;
  padding-top: 15px;
  border-bottom: 1px solid #d0d0d0;
 }
.right_tow{
  margin-top: 10px;
  width: 99%;
  height: 50px;
  display: flex;
   justify-content: space-between;
   border-bottom: 1px solid #d0d0d0;
}
.right_tow_left{
  margin-left: 10px;
  width: 20%;
  height: 90%;
   text-align:center;
}
.right_tow_right{
   width:40%;
  height: 90%;


}
</style>



// WEBPACK FOOTER //
// src/view/visitor/TeacherCurriculumList.vue